<template>
    <div>
        <h3 class="text-center"
            v-text="jsonObjectTurism.turism"></h3>
    </div>   
</template>

<script>
import jsonObjectTurism from './Turism.json';
export default {

data () {
    return {
        jsonObjectTurism,
        
    }
  },
}


</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EN-vers/menu/Turism.vue